// extracted by mini-css-extract-plugin
export default {"mCard":"VA-z","image":"WA-z","imageNoBackground":"XA-z","imageHasCategory":"YA-z","fullWidth":"ZA-z"};